"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
class Transformation {
    constructor(name, rules = immutable_1.List()) {
        this.name = name;
        this.rules = rules;
    }
    addRule(rule) {
        return new Transformation(this.name, this.rules.push(rule));
    }
    toString() {
        return `[\n\xa0\xa0${this.rules.join(`,\n\xa0\xa0`)}\n]`;
    }
    equals(other) {
        return (other !== undefined &&
            this.constructor === other.constructor &&
            this.rules.every((rule, index) => rule.equals(other.rules.get(index))));
    }
    execute(namespace) {
        return {
            namespace: Object.assign({}, namespace, { transformations: namespace.transformations.set(this.name, this) }),
            stdOut: this.toString(),
        };
    }
}
exports.default = Transformation;
//# sourceMappingURL=Transformation.js.map